import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { changeStore } from "../redux/storesSagas";
import { storesApi } from "../api";
import { object, string } from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

const schema = object({
  name: string().label("Name").required("Name is required")
}).required();

export const useEdit = ({ id, orgName }) => {
  const dispatch = useDispatch();

  const getDefaultValues = async () => {
    let { data } = await storesApi.getStoreDetails({ params: { id: id.toString() } });

    const {
      organizationId,
      clubreadyChainId,
      remoteUid,
      name,
      inactive,
      firstCalculationDate,
      firstRevenueCalculationDate,
      organizationName,
      clubreadyChainUid,
      opened,
      storeStatus,
      forceActive
    } = data;

    return {
      store_id: id,
      clubready_chain_uid: clubreadyChainUid,
      organization_id: organizationId,
      organization_name: organizationName,
      clubready_chain_id: clubreadyChainId,
      remote_uid: remoteUid,
      name,
      inactive,
      first_calculation_date: firstCalculationDate,
      first_revenue_calculation_date: firstRevenueCalculationDate,
      opened,
      store_status: storeStatus,
      force_active: forceActive
    };
  };

  const form = useForm({
    resolver: yupResolver(schema),
    defaultValues: getDefaultValues
  });

  let {
    handleSubmit,
    formState: { dirtyFields }
  } = form;

  const onSubmit = (data) => {
    let changedFieldKeys = Object.keys(dirtyFields);
    let formattedDataForRequest = {};
    changedFieldKeys.forEach((key) => {
      formattedDataForRequest = { ...formattedDataForRequest, [key]: data[key] };
    });
    dispatch(changeStore({ data, id, orgName, organizationId: data.organization_id }));
  };

  return {
    form,
    submit: handleSubmit(onSubmit)
  };
};
